<template>
<v-container>
  <v-card>
    <v-card-title>
      <strong>Gestione Utenti</strong>
      <v-btn fab dark small color="#4EABDD" @click="insertNewRecord()">
        <v-icon dark>add</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <v-text-field outline append-icon="search" label="Cerca" single-line hide-details v-model="search"></v-text-field>
    </v-card-title>
    <v-data-table v-bind:headers="headers" v-bind:items="items" v-bind:search="search">
      <template slot="items" slot-scope="props">
        <tr @click="updateRecord(props.item.id)">
          <td class="text-xs-left">{{ props.item.id }}</td>
          <td class="text-xs-left">{{ props.item.codice }}</td>
          <td class="text-xs-left">{{ props.item.codFat }}</td>
          <td class="text-xs-left">{{ props.item.email }}</td>
          <td class="text-xs-left">{{ props.item.displayName }}</td>
          <td class="text-xs-left">{{ props.item.enabled }}</td>
          <td class="text-xs-left">{{ props.item.lastLogin }}</td>
           <td class="text-xs-left">{{ props.item.gruppo }}</td>
        </tr>
      </template>
      <template
        slot="pageText"
        slot-scope="{ pageStart, pageStop }"
      >From {{ pageStart }} to {{ pageStop }}</template>
    </v-data-table>
  </v-card>
  </v-container>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      tmp: "",
      search: "",
      pagination: {},
      gruppi: {},
      headers: [
        { text: "Id", align: "left", value: "id" },
        { text: "Codice cliente", align: "left", value: "codice" },
        { text: "Codice fatt.", align: "left", value: "codFat" },
        { text: "Email", align: "left", value: "email" },
        { text: "Display Name", align: "left", value: "displayName" },
        { text: "Attivo", align: "left", value: "enabled" },
        { text: "Ultimo login", align: "left", value: "lastLogin"},
        { text: "Gruppo", align: "left", value: "gruppo"},
      ],
      items: [],
      desGruppi: {}

    };
  },
  created(){
    this.$store.dispatch("ImpostaScollegamento");
  },
  mounted() {
    this.CheckJWT();
    this.GetDescrizioniGruppi();
  },
  methods: {
    GetDescrizioniGruppi(){
      this.loading = true;
      axios.get(this.$store.state.servicePath + "/api/ArGruppis").then(res => {
        this.desGruppi = [];
        res.data.forEach(el=>{
          this.desGruppi[el.id] = el.descrizione;
        });
        this.GetGruppi();
      });
    },
    GetGruppi(){
      axios.get(this.$store.state.servicePath + "/api/ArGruppiUtentis").then(res => {
        res.data.forEach(el=>{
          this.gruppi[el.idUtente] = this.desGruppi[el.idGruppo];
        });
        this.getDataFromService();
      });
    },
    getDataFromService() {
      this.loading = true;
      axios.get(this.$store.state.servicePath + "/api/ArUtentis").then(res => {
        this.items = [];
        res.data.forEach(el=>{
          var element = el;
          element.gruppo = this.gruppi[element.id];
          this.items.push(element);
        });
        this.loading = false;
      });
    },

    insertNewRecord() {
      this.$router.push({ path: `/utenti/0` });
    },

    updateRecord(recid) {
      this.$router.push({ path: `/utenti/${recid}` });
    },
    CheckJWT() {
      axios
        .post(this.$store.state.servicePath + "/api/Login/checkJwt", {
          route: this.$route.path
        })
        .then(res => {
          if (res.data.status == "ko") {
            this.$router.push({ path: `/errore` });
          }
        })
        .catch(err =>{
          this.$router.push({ path: `/errore` });
        });
    }
  }
};
</script>